/**
 * LandingWhoItsFor — four persona blocks, light surface.
 *
 * Visually mirrors NoRework's "Who it's for" section: four
 * centred icon-tile-and-text blocks. Each persona block is a
 * single-paragraph value pitch — the field operator, the
 * facilities manager, the property manager, the contractor.
 */

import { type ReactNode }                              from 'react'
import { GraduationCap, Building2, Home, Sparkles }    from 'lucide-react'
import {
  PERSONAS_HEADLINE,
  PERSONAS_SUBHEAD,
  PERSONAS,
  type PersonaCard,
}                                                      from './landingCopy'

const ICON_BY_NAME: Record<PersonaCard['icon'], typeof Home> = {
  GraduationCap,
  Building2,
  Home,
  Sparkles,
}

export function LandingWhoItsFor(): ReactNode {
  return (
    <section className="landing-section" aria-labelledby="personas-h">
      <div className="landing-section__inner">
        <h2 id="personas-h" className="landing-section__eyebrow">{PERSONAS_HEADLINE}</h2>
        <p className="landing-section__lede">{PERSONAS_SUBHEAD}</p>

        <div className="personas-grid">
          {PERSONAS.map((p) => {
            const Icon = ICON_BY_NAME[p.icon]
            return (
              <article key={p.title} className="persona">
                <span className="icon-tile icon-tile--orange">
                  <Icon size={22} strokeWidth={2} />
                </span>
                <h3>{p.title}</h3>
                <p>{p.body}</p>
              </article>
            )
          })}
        </div>
      </div>
    </section>
  )
}
